<template>

  <footer class="box-footer -bg-darkblue">
    <div class="container">
      <div class="row">
        <div class="column">
          <p class="mx-legal">Descarga los <a href="/static/pdf/terminos-condiciones-mx.pdf" target="_blank">Términos y Condiciones</a> y <a href="/static/pdf/politicas-privacidad-mx.pdf" target="_blank">Políticas de Privacidad</a> de Cumplo México. Conoce tus <a href="https://noticias.cumplo.mx/2020/02/16/ya-conoces-tus-beneficios-como-inversionista-cumplo/" target="_blank">beneficios como inversionista aquí</a>. Consulta las <a href="https://noticias.cumplo.mx/2019/08/26/seguridad-en-tu-operacion-recomendaciones-de-uso-de-plataforma/" target="_blank">recomendaciones de seguridad</a>. Infórmate sobre nuestras <a href="https://noticias.cumplo.mx/2019/08/27/diversifica-tus-inversiones/" target="_blank">Políticas de diversificación</a>.
            <br>
            Recuerda que el costo por cobranza de cada inversión es del 0.2% del capital pagado más I.V.A. mensual.
            Ingresa tus
              <a href="https://consultasyreclamaciones.cumplo.mx/support/tickets/new" target="_blank">
                Dudas o Reclamaciones.
              </a>
          </p>
        </div>
      </div>
      <div class="row row-responsive info">
          <div class="column column-xs-100 column-sm-60">
            <h2 class="maintitle -xsmall -align-left">¿Necesitas más información?</h2>
            <p class="call-us">
              <img src="/static/svg/icons_clarity-phone-handset.svg">
              Llámanos
              <a href="tel:5571002310" class="phone-number -yellow">(55) 7100 2310</a>
              <br>
              <img src="/static/svg/icons_fontawesome-whatsapp.svg">
              WhatsApp
              <a href="https://wa.me/5215534602133" class="phone-number -yellow">(55) 3460 2133</a> -
              <a href="https://wa.me/5215620398803" class="phone-number -yellow">(56) 2039 8803</a>
              <br>
              <img src="/static/svg/icons_clarity-email.svg">
              Escríbenos
              <a href="mailto:contacto.mx@cumplo.com" class="phone-number -yellow">contacto.mx@cumplo.com</a>
            </p>
            <div class="social-links">
              <a href="https://www.facebook.com/cumploMX/" target="_blank" class="social-link-button">
                <img src="/static/svg/icons_fontawesome-facebook-footer.svg">
              </a>
              <a href="https://twitter.com/cumploMX" target="_blank" class="social-link-button">
                <img src="/static/svg/icons_fontawesome-twitter-footer.svg">
              </a>
              <a href="https://www.instagram.com/cumplomx/" target="_blank" class="social-link-button">
                <img src="/static/svg/icons_fontawesome-instagram-footer.svg">
              </a>
              <a href="https://www.linkedin.com/company/cumplo/" target="_blank" class="social-link-button">
                <img src="/static/svg/icons_fontawesome-linkedin-footer.svg">
              </a>
              <a href="https://www.youtube.com/channel/UCUX1hPS59JLlGAZut2IlN-Q/" target="_blank" class="social-link-button">
                <img src="/static/svg/icons_fontawesome-youtube-footer.svg">
              </a>
              <a href="https://www.pinterest.com.mx/cumplomx/" target="_blank" class="social-link-button">
                <img src="/static/svg/icons_fontawesome-pinterest-footer.svg">
              </a>
            </div>
          </div>
          <div>
            <div>
              <p class="commissions-footer">Consulta los Costos y las Comisiones de nuestros productos
                <router-link :to="{name: 'Commissions'}">aqui</router-link>
              </p>
            </div>
            <div class="row">
              <div class="column column-50">
                <div class="box-brands-footer">
                  <p class="title">Certificados como:</p>
                  <a href="https://sistemab.org/" target="_blank">
                    <img src="/static/svg/empresa-b.svg" alt="Empresa B">
                  </a>
                </div>
              </div>
            <div class="column column-50">
              <div class="box-brands-footer">
                <p class="title">Miembros de:</p>
                <a href="http://fintechmexico.org" target="_blank">
                  <img class="fintech" src="/static/svg/logo-fintech.svg" alt="Fintech México">
                </a>
              </div>
            </div>
            </div>
            </div>
          </div>
        </div>
  </footer>

</template>

<script>

export default {
  name: 'FooterComponent',
  data () {
    return {
    }
  }
}

</script>

<style lang="scss" scoped>

.box-footer {
  color: $white;
  padding: 5rem 0;

  .phone-number {
    font-weight: 500;
    transition: color .3s ease;

    &:hover,
    &:focus {
      color: darken($yellow, 20%);
    }
  }

  .call-us {
    font-size: 1.25em;
  }

  .social-links {
    display: flex;
  }

  .social-link-button {
    align-items: center;
    background: $white;
    border-radius: 50%;
    color: $midnight-blue;
    display: flex;
    height: 30px;
    justify-content: center;
    margin: 0 1rem 0 0;
    width: 30px;
  }

  .mx-disclaimer,
  .mx-legal {
    font-size: 13px;
    border-bottom: 1px solid #8c8c8c;
    padding-bottom: 2rem;
    margin: 0 0 2rem;

    a {
      color: $yellow;

      &:hover,
      &:focus {
        color: darken($yellow, 20%);
      }
    }
  }

  .box-brands-footer {
    text-align: center;

    .title {
      margin-bottom: 1rem;
      font-size: .8em;
    }
  }
  .commissions-footer {
    font-size: 13px;
    a {
      color: $yellow;
    &:hover{
       color: darken($yellow, 20%)
    }

}
  }
  .info{
    flex-wrap: initial
  }
  .fintech{
    max-width: 80%;
  }
}
</style>



// WEBPACK FOOTER //
// src/partials/Footer.vue